import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const NotFound = () => (
  <main className="textPage textPage--center">
    <SEO title="Not found | Jonny Coe Photography" noindex />
    <h1 className="label textPage__label">404</h1>
    <p className="textPage__lede">Nothing here — the trail ends.</p>
    <Link to="/work" className="detailNav__all">
      ← Back to the work
    </Link>
  </main>
);

export default NotFound;
